import { render, staticRenderFns } from "./DentistList.vue?vue&type=template&id=aea804be&"
import script from "./DentistList.vue?vue&type=script&lang=js&"
export * from "./DentistList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports